import React, {Component} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {Button, Card, CardDeck, CardText} from 'reactstrap';
import {Link} from 'react-router-dom';
import './CreateAccount.css';
import {sharedLabelsPath} from "../../../reducers/common/localization";
import BackButtonComponent from "../../commonComponents/backButtonComponent/BackButtonComponent";

class CreateAccount extends Component {
    render() {
        // TODO: change link http to https
        return (
            <div className='create-account-container'>
                <BackButtonComponent path='/login' label={_.get(this.props.translation, sharedLabelsPath.back_button)}/>
                <div className='create-account-box-container'>
                    <h4 className='text-center'>{_.get(this.props.translation, 'login.create_account_alert')}</h4>
                    <div className='buttons-group'>
                        <CardDeck>
                            <Card body className="text-center">
                                <CardText>
                                    {_.get(this.props.translation, 'login.create_an_label') + ' '}
                                    <b>{_.get(this.props.translation, 'login.applicant_button') + ' '}</b>
                                    {_.get(this.props.translation, 'login.applicant_account_hint')}
                                </CardText>
                                <Button tag={Link} to='/applicant-registration'
                                        className="olive-green-btn">{_.get(this.props.translation, 'login.applicant_button')}</Button>
                            </Card>
                            <Card body className="text-center">
                                <CardText>
                                    {_.get(this.props.translation, 'login.create_a_label') + ' '}
                                    <b>{_.get(this.props.translation, 'login.company_button') + ' '}</b>
                                    {_.get(this.props.translation, 'login.company_account_hint')}
                                </CardText>
                                <Button tag={Link} to='/company-registration'
                                        className="olive-green-btn">{_.get(this.props.translation, 'login.company_button')}</Button>
                            </Card>
                        </CardDeck>
                    </div>
                </div>
                <div className="hint-message">
                    {_.get(this.props.translation, 'login.more_info_label') + ' '}
                    <a href='http://www.brainchainmission.org' target="_blank"
                       rel="noopener noreferrer">www.brainchainmission.org</a>
                </div>
            </div>
        );
    }
}

CreateAccount.propTypes = {
    translation: PropTypes.object
};

export default CreateAccount;



// WEBPACK FOOTER //
// ./src/components/accountManagement/createAccount/CreateAccount.js